import React, { DispatchWithoutAction, FC } from 'react';

import { fc } from 'i18n';
import Button from 'core/react/general/form/Button';
import { ReactPortal } from 'components/molecules/react-portal';

import styles from './styles.module.css';

interface IModalProps {
  position: Record<string, number>;
  onCancel: DispatchWithoutAction;
  deactivateDevice: DispatchWithoutAction;
}

export const ConfirmDeleteModal: FC<IModalProps> = (props) => {
  const { position, onCancel, deactivateDevice } = props;

  return (
    <ReactPortal>
      <div className={styles.confirmDelete} style={{ ...position }}>
        <div>Deactivate device?</div>
        <div className={styles.confirmDeleteButtons}>
          <Button className={styles.cancelConfirmDelete} onClick={onCancel}>
            {fc('cancel')}
          </Button>
          <Button className={`${styles.cancelConfirmDelete} active`} onClick={deactivateDevice}>
            {fc('deactivate')}
          </Button>
        </div>
      </div>
    </ReactPortal>
  );
};
